import { render, staticRenderFns } from "./Schedule7NumberofYearsinSR.vue?vue&type=template&id=4c681efe&"
import script from "./Schedule7NumberofYearsinSR.vue?vue&type=script&lang=js&"
export * from "./Schedule7NumberofYearsinSR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports